export default __webpack_public_path__ + "static/media/861.93970add.gif";